const charAt = `
 _____               _____               _ 
|   __|___ ___ _ _ _| __  |___ ___ ___ _| |
|  |  |  _| . | | | | __ -|  _| -_| .'| . |
|_____|_| |___|_____|_____|_| |___|__,|___|
`;

export default () => console.info(`%c${charAt}`, 'color: #5BE49B');
